var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61,
    height: 53.67,
    viewBox: "0 0 61 53.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14628",
    "data-name": "Group 14628",
    transform: "translate(-82 -316.33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-images",
    "data-name": "Icon ionic-ios-images",
    transform: "translate(79.75 314.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M22.456,14.1a.522.522,0,0,0-.848-.077L11.485,27.484a.515.515,0,0,0,.352.848l17.746,1.542a.524.524,0,0,0,.5-.782Z",
    transform: "translate(5.162 6.568)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M27.159,18.664a.522.522,0,0,0-.848-.077l-2.732,2.765a.515.515,0,0,0-.055.595l2.8,5.453a.513.513,0,0,0,.408.253l4.946.43a.524.524,0,0,0,.5-.782Z",
    transform: "translate(12.015 9.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M27.546,17.663a2.605,2.605,0,1,0-2.611-3.1A2.626,2.626,0,0,0,27.546,17.663Z",
    transform: "translate(12.828 5.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M48.868,12.969l-7.248-.628-.672-7.38a2.976,2.976,0,0,0-3.25-2.7L4.971,5.214a2.988,2.988,0,0,0-2.71,3.239L5.213,41.113a2.976,2.976,0,0,0,3.25,2.7l1.729-.154-.165,1.84a2.979,2.979,0,0,0,2.721,3.228L45.5,51.578a2.988,2.988,0,0,0,3.239-2.71L51.6,16.2A3,3,0,0,0,48.868,12.969ZM8.375,31.849a.758.758,0,0,1-.815-.672L5.577,9.146a.741.741,0,0,1,.672-.8L37,5.577a.758.758,0,0,1,.815.672l.529,5.816L16.13,10.116a2.988,2.988,0,0,0-3.239,2.71L11.25,31.585Zm39.9-14.937L46.345,38.943a.75.75,0,0,1-.8.683l-2.049-.176-28.717-2.5a.75.75,0,0,1-.683-.8l.419-4.836,1.509-17.2a.75.75,0,0,1,.8-.683l21.811,1.906,3.272.286,5.684.5A.719.719,0,0,1,48.273,16.912Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    transform: "translate(114 341)",
    fill: "#bd8ef2",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-add",
    "data-name": "Icon ionic-ios-add",
    d: "M22.08,14.713H16.828V9.782a.872.872,0,0,0-1.741,0v4.931H9.836a.848.848,0,0,0-.871.818.791.791,0,0,0,.256.577.9.9,0,0,0,.615.24h5.251v4.931a.791.791,0,0,0,.256.577.9.9,0,0,0,.615.24.848.848,0,0,0,.871-.818V16.348H22.08a.819.819,0,1,0,0-1.635Z",
    transform: "translate(113.035 340.035)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/upload-photo.cd3dc72e7622e9d9a24a4c2006e487ba.svg";
export { ForwardRef as ReactComponent };